import React from 'react'
import Layout from '../../Layout'
import Item from "./Components/Item"
import Category from "../Category"
import { useStoreList } from '../../Hook/App'
import HeaderMain from '../../Components/HeaderMain'
import Shop from '../../Components/Shop'
import InfiniteList from '../../Components/InfiniteList'
function Index() {
    const { category, stores, changeText, setPage, page, selectCategory } = useStoreList()
    if (page === 'selectCategory') {
        return <Category callback={selectCategory} />
    }
    return (
        <Layout>
            <HeaderMain lable="فروشگاه ها" />

            <div className="stors-main  pt-5">
                <input type="text" onChange={changeText} className='mt-5  box' placeholder='جستجو کنید' />
                <div className="box" onClick={() => { setPage('selectCategory') }}>
                    {category ? category.title : "همه گروهبندی ها"}
                </div>
                <div className="d-flex my-3">
                    <span className="light">ویترین</span>
                </div>

                <div className='main'>
                    <InfiniteList keyList="stores">
                        {stores && stores.data &&
                            stores.data.map((shop, i) => {
                                return <Shop link={'/StoreSingle/' + shop.id + "/" + shop.user_id} item={shop} key={i} />
                            })
                        }
                    </InfiniteList>
                </div>
            </div>
        </Layout>
    )
}

export default Index